export default __webpack_public_path__ + "static/media/df.7bda10e4.png";